import { generatePath } from 'react-router'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { IMAGE_SIZES, URL_PAGE_PRODUCT_GROUP } from '@shared/contants'
import { Product, useSingleProductGroupQuery } from '@shared/generated'




type ProductsGroupCarouselProps = {
  id: string
}

export default function ProductsGroupCarousel ({
  id
}: ProductsGroupCarouselProps) {
  const { shopId } = useAddressStore()
  
  const { data, loading } = useSingleProductGroupQuery({
    variables: {
      id,
      shop_id: shopId,
      style: IMAGE_SIZES.LARGE,
    }
  })

  return (
    <>
      {data && (
        <ProductCarousel
          link={generatePath(URL_PAGE_PRODUCT_GROUP, {
            productGroupId: data.singleProductGroup?.id as string
          })}
          title={data.singleProductGroup?.label ?? ''}
          products={data.singleProductGroup?.products as Product[]}
          loading={loading}
          listName={`Product Group: ${data.singleProductGroup?.label ?? ''}`}
          listId={data.singleProductGroup?.id ?? undefined}
        />
      )}
    </>
  )
};